<template>
  <van-skeleton
    avatar
    avatar-shape="square"
    avatar-size="50"
    :row="2"
    :loading="loading"
  >
    <van-row
      :gutter="gutter"
      type="flex"
      align="top"
      :class="customClass"
      @click="click"
    >
      <van-col :span="iconSpan">
        <ShowImage
          source="cdn"
          :imgId="episodeData.cover"
          :radius="5"
        />
      </van-col>
      <van-col :span="bodySpan" :offset="offset">
        <strong>{{episodeData.title}}</strong>
        <div v-if="showDescription" class="van-multi-ellipsis--l2 desc">
          {{episodeData.description}}
        </div>
        <van-row gutter="15" type="flex" justify="start" align="center" class="meta">
          <van-col v-if="showPrice" span="">
            <span class="price">{{price}}</span>
          </van-col>
          <van-col span="">
            {{duration}}
          </van-col>
          <van-col v-if="showPubtime">
            {{datetime}}
          </van-col>
          <van-col v-if="showRating">
            <div style="display:flex;align-items:center;">
              <van-rate
                v-model="rateValue"
                allow-half
                void-icon="star"
                void-color="#eee"
                size="14"
                readonly
              />
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </van-skeleton>
</template>

<script>
  import {humanDuration, humanDateTime} from '../utils/time.js'
  import ShowImage from './show-image.vue'
  import Vue from 'vue'
  import { Row, Col } from 'vant'
  // import { Image } from 'vant'
  import { Skeleton } from 'vant'
  import { Rate } from 'vant'
  Vue.use(Row).use(Col)
  // Vue.use(Image)
  Vue.use(Skeleton)
  Vue.use(Rate)

  export default {
    components: {
      ShowImage
    },
    props: {
      episode: {
        type: Object,
        default: function () {
          return {
            title: '',
            description: '',
            cover: 0,
            price: {
              amount: 0,
              origin: 0
            }
          }
        }
      },
      episodeId: Number,
      parentCommentId: Number,
      compact: { // 紧凑模式
        type: Boolean,
        default: false
      },
      showDescription: { // 显示简介
        type: Boolean,
        default: true
      },
      showPrice: { // 显示价格
        type: Boolean,
        default: true
      },
      showRating: { // 显示评分
        type: Boolean,
        default: false
      },
      showPubtime: { // 显示发布时间
        type: Boolean,
        default: true
      },
      clickDisabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      // episodeData () {
      //   if (this.episodeId != 0) {
      //     window.console.log("获取到了episodeId")
      //     let that = this
      //     let params = {episodeId: this.episodeId}
      //     that.$api.comment.detail(params).then(res => {
      //       return res.data
      //     })
      //   } else {
      //     return this.episode
      //   }
      // },
      gutter () {
        if (this.compact) {
          return 0
        } else {
          return 15
        }
      },
      offset () {
        if (this.compact) {
          return 1
        } else {
          return 0
        }
      },
      iconSpan () {
        if (this.compact) {
          return 3
        } else {
          return 5
        }
      },
      bodySpan () {
        if (this.compact) {
          return 21
        } else {
          return 19
        }
      },
      customClass () {
        if (this.compact) {
          return 'compact'
        } else {
          return null
        }
      },
      duration () {
        return humanDuration(this.episodeData.seconds)
      },
      datetime () {
        return humanDateTime(this.episodeData.created)
      },
      price () {
        let price = this.episodeData.price.amount / 100
        if (price == 0) {
          return '免费'
        } else {
          return '¥' + String(price.toFixed(2))
        }
      },
      // loading () {
      //   if (this.episodeData.title.length > 0) {
      //     return false
      //   } else {
      //     return true
      //   }
      // }
    },
    watch: {
      episodeId (value) {
        if (value != 0) {
          let that = this
          that.$api.episode.detail(value).then(res => {
            that.episodeData = res.data
            that.loading = false
          })
        }
      }
    },
    data () {
      return {
        rateValue: 4.5,
        loading: true,
        episodeData: this.episode
      }
    },
    methods: {
      click () {
        if (!this.clickDisabled) {
          this.$router.replace({
            name: 'EpisodeDetail',
            params: {
              episodeId: this.episodeData.id
            }
          })
        }
      }
    },
    mounted () {
      let that = this
      if (that.episodeId) {
        that.$api.episode.detail(that.episodeId).then(res => {
          that.episodeData = res.data
          that.loading = false
        })
      } else if (that.parentCommentId) {
        window.console.log("获得parentCommentId")
        that.$api.comment.detail(that.parentCommentId).then(res => {
          that.$api.episode.detail(res.data.object_id).then(res => {
            that.episodeData = res.data
            that.loading = false
          })
        })
      } else {
        if (that.episodeData.title.length >0) {
          that.loading = false
        }
      }
    }
  }
</script>

<style lang="css" scoped>
  .desc {
    margin: 5px 0;
    color: #666;
    line-height: 125%;
  }
  .meta {
    font-size: 0.9em;
    color: #999;
  }
  .price {
    color: #e9192d
  }
  div.compact {
    background: #fafafa;
    padding: 2px 5px;
    display: flex;
    align-items: center;
  }
  img.compact {
    display: block;
    margin-right: 15px;
  }
</style>
